// Matches backend users/admin-account-security.contract.ts for distributor setup/reset only.
// Existing sign-in and self-service password-change contracts are intentionally separate.
export const DISTRIBUTOR_PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{12,72}$/;

export const DISTRIBUTOR_PASSWORD_REQUIREMENT =
  'Use 12-72 characters with uppercase and lowercase letters, a number, and one of @$!%*?&#. Only letters, numbers, and these symbols are allowed.';
